<script setup>
const props = defineProps(['id', 'label', 'options'])
const model = defineModel()
</script>

<template>
    <div class="field field--switcher">
        <fieldset class="switcher">
            <legend v-html="label"></legend>
            
            <div class="options">
                <div v-for="option in options" class="option">
                    <input type="radio" :name="`attribute-${id}`" :value="option" :id="`attribute-${id}-${option.id}`" v-model="model" required>
                    <label :for="`attribute-${id}-${option.id}`" v-html="option.label"></label>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<style scoped lang="scss">
.switcher {
    border: none;
    margin: 0;
    padding: 0;
}
</style>
